module.exports = __webpack_public_path__ + "media/images/web/landings/students/s1-3ce05f1f85420c8c90520226a1efeecf.jpg";